var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDocument = function SvgDocument(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Style-Guide",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-666.000000, -18743.000000)",
    id: "Group-7",
    stroke: "currentColor",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(383.000000, 18729.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CTA-Button---MD---Form"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Doc-Icon",
    transform: "translate(284.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 3.46992,
    y1: 7.084785,
    x2: 8.12082,
    y2: 7.084785,
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.46992,
    y1: 10.48092,
    x2: 13.62702,
    y2: 10.48092,
    id: "Stroke-2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.46992,
    y1: 13.877055,
    x2: 13.62702,
    y2: 13.877055,
    id: "Stroke-3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.46992,
    y1: 17.27319,
    x2: 13.62702,
    y2: 17.27319,
    id: "Stroke-5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.46992,
    y1: 3.68865,
    x2: 8.12082,
    y2: 3.68865,
    id: "Stroke-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.02545,0.30003 L0.64095,0.30003 C0.28695,0.30003 0.00015,0.58713 0.00015,0.94083 L0.00015,20.05503 C0.00015,20.40993 0.28785,20.69793 0.64305,20.69793 L16.48785,20.69793 C16.84275,20.69793 17.13075,20.40993 17.13075,20.05503 L17.13075,16.07103 L17.13075,6.40563",
    id: "Stroke-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.12784,6.40566 L11.77104,6.40566 C11.35914,6.40566 11.02554,6.07176 11.02554,5.66016 L11.02554,0.30006 L17.12784,6.40566 Z",
    id: "Stroke-9"
  }))))))));
};
export { SvgDocument as ReactComponent };
export default "data:image/svg+xml;base64,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";